import StopMarker from './StopMarker';

export default StopMarker;
